import { combineReducers } from 'redux';
import { Selector } from '@reduxjs/toolkit';
import { appReducer } from './modules/app/reducer';
import { routerReducer } from './modules/router/reducer';
import { projectReducer } from './modules/project/reducer';
import { categoryReducer } from './modules/category/reducer';
import { tagReducer } from './modules/tag/reducer';
import { tagBinderReducer } from './modules/tagBinder/reducer';
import { viewerReducer } from './modules/viewer/reducer';
import { viewModeReducer } from './modules/viewMode/reducer';
import { extensionReducer } from './modules/extension/reducer';
import { sortingReducer } from './modules/sorting/reducer';
import { searchReducer } from './modules/search/reducer';
import { finderReducer } from './modules/finder/reducer';
import { packReducer } from './modules/pack/reducer';
import { favoriteReducer } from './modules/favorite/reducer';
import { sharingReducer } from './modules/sharing/reducer';
import { sharingLinkReducer } from './modules/sharingLink/reducer';
import { lastStateReducer } from './modules/lastState/reducer';
import { assetLinkReducer } from './modules/assetLink/reducer';
import { figmaImportReducer } from '../creativeHub/modules/figmaImport/logic';
import { fullscreenPreviewReducer } from './modules/fullscreenPreview/reducer';
import { commentReducer } from './modules/comment/reducer';
import { googleBulkReducer } from './modules/googleBulk/reducer';
import { previewReducer } from './modules/preview/reducer';
import { magicStudioReducer } from './modules/magicStudio/reducer';
import { uploaderReducer } from './modules/uploader/reducer';
import { filtersCacheReducer } from './modules/filtersCache/reducer';

export const rootReducer = combineReducers({
  app: appReducer,
  router: routerReducer,
  project: projectReducer,
  category: categoryReducer,
  tag: tagReducer,
  tagBinder: tagBinderReducer,
  viewer: viewerReducer,
  viewMode: viewModeReducer,
  extension: extensionReducer,
  sorting: sortingReducer,
  search: searchReducer,
  finder: finderReducer,
  pack: packReducer,
  favorite: favoriteReducer,
  sharing: sharingReducer,
  sharingLink: sharingLinkReducer,
  lastState: lastStateReducer,
  assetLink: assetLinkReducer,
  figmaImport: figmaImportReducer,
  fullscreenPreview: fullscreenPreviewReducer,
  comment: commentReducer,
  googleBulk: googleBulkReducer,
  preview: previewReducer,
  magicStudio: magicStudioReducer,
  uploader: uploaderReducer,
  filtersCache: filtersCacheReducer,
});

export type RootStore = ReturnType<typeof rootReducer>;

export type RootSelector<T> = Selector<RootStore, T>;
export const getStore = (s: RootStore) => s;
